import { freedomApp } from 'freedom-shared';

export const readPdf = (data: Blob, isDev: boolean) => {
  const mimeType = 'application/pdf';
  const blobFile = new Blob([data], { type: mimeType });
  const reader = new FileReader();
  reader.readAsDataURL(blobFile);
  reader.onloadend = () => {
    const { result } = reader;

    /**
     * Open ticket PDF in new tab for development mode.
     * In production - pass base64 file string to native app API
     */
    if (isDev) {
      const fileURL = window.URL.createObjectURL(blobFile);
      window.open(fileURL, '_blank');
    } else {
      freedomApp.lib.openBase64File(
        JSON.stringify({
          /**
           * Result is a string in format data:application/pdf;base64,JVBERi0xLjQK...
           * We need to pass only base64 string without prefix, so we split and take only the string
           */
          base64File: String(result).split(',')[1],
          fileType: 'pdf',
        }),
      );
    }
  };
};
